import { createFileRoute } from '@tanstack/react-router';

import { billingSettingListScreen, billingSettingListSearch, loadBillingSettingMessages, loadBillingSettingScreen } from '@/modules/billing-setting/route';
import { lazyScreen } from '@/shared/screen';

// Régua de cobrança no caminho do legado (`router.tsx:1439-1443`): o menu passa a apontar para cá
// quando o manifesto entra em `src/app/screens.ts`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/gestao-carteira/parametros/')({
  validateSearch: billingSettingListSearch,
  staticData: { screen: billingSettingListScreen },
  loader: () => loadBillingSettingMessages(),
   
  component: lazyScreen(loadBillingSettingScreen, 'BillingSettingRouteScreen'),
});
